<template>
  <div class="app">
    <Transition>
      <div v-if="pageLoaded && currentLanguage" id="page" class="app__wrapper">
        <Header
          :currency-code="currencyCode"
          :currency-options="currencyOptions"
          :currency-code-id="currencyCodeId"
          :cart-contents="cartContents"
          :is-auth="isAuth"
          :is-scrolable="isScrolable"
          :menu-visible="menuVisible"
          @changeCurrency="changeCurrency"
          @openSignIn="openSignIn"
          @openSignUp="openSignUp"
          @removeOneFromCart="removeOneFromCart"
          @openSellSkinModal="openSellSkinModal"
          @closeMenu="closeMenu"
          @toggleMenu="toggleMenu"
        />
        <div class="app__content">
          <div class="app__content-bg _ibg">
            <img src="@/assets/img/bg/page-bg.png" />
          </div>
          <router-view
            :minTopupAmount="minTopupAmount"
            :currency-code="currencyCode"
            :lang="currentLanguage"
            :currency-symbol="currencySymbol"
            :text-page-title="textPageTitle"
            :text-page-header="textPageHeader"
            :text-page-content="textPageContent"
            :is-auth="isAuth"
            :order-history="orderHistory"
            :total-sum="totalSum"
            :error="error"
            :cart-contents="cartContents"
            :hostname="hostname"
            :footer-support-email="footerSupportEmail"
            :chosen-item="chosenItem"
            :successMessage="successMessage"
            :loader-is-visible="loaderIsVisible"
            :showResendOption="showResendOption"
            :offer-history="offerHistory"
            :preview-skin-modal-is-visible="previewSkinModalIsVisible"
            :refresh-offer-history="getOfferHistory"
            :payment-methods="allPaymentMethods"
            @formatDate="formatDate"
            @offerCreated="onOfferCreated"
            @goToProduct="goToProduct"
            @openSignUp="openSignUp"
            @openSellSkinModal="openSellSkinModal"
            @openPreviewSkinModal="openPreviewSkinModal"
            @closePreviewSkinModal="closePreviewSkinModal"
            @openSignIn="openSignIn"
            @logout="logout"
            @addToCart="addToCart"
            @removeOneFromCart="removeOneFromCart"
            @removeFromCart="removeFromCart"
            @openOrderModal="openOrderModal"
            @openWithdraw="openWithdraw"
            @login="login"
            @forgotPass="forgotPass"
            @clearError="clearError"
            @hideResendOption="hideResendOption"
            @resendVerificationEmail="resendVerificationEmail"
            @registration="registration"
          />
        </div>

        <Footer
          :isAuth="isAuth"
          :text-page-list="textPageList"
          :footer-requisites="footerRequisites"
          :footer-support-email="footerSupportEmail"
          :footerCopyright="footerCopyright"
          :paymentMethods="allPaymentMethods"
          @openSignIn="openSignIn"
          @openSellSkinModal="openSellSkinModal"
        />

        <Transition>
          <SellSkinModal
            v-if="sellSkinModalIsVisible"
            :currency-symbol="currencySymbol"
            @setError="setError"
            @openOrderModal="openOrderModal"
            @offerCreated="onOfferCreated"
            :error="error"
            @closeSellSkinModal="closeSellSkinModal"
          />
        </Transition>
        <!--<Transition>
					<PayoutModal
						v-if="withdrawModalIsVisible"
						:currencyCode="currencyCode"
						:currency-symbol="currencySymbol"
						@closeWithdraw="closeWithdraw"
						@openSignIn="openSignIn"
					/>
				</Transition>-->

        <CookiesModal />
      </div>
    </Transition>
  </div>
</template>

<script>
import {
  COOKIE_PAGE,
  PRIVACY_PAGE,
  TERMS_PAGE,
} from '@/store/modules/staticPages'
import { loadScriptsFromString } from '@/utils/load_scripts'
import { mapActions, mapGetters, mapState } from 'vuex'
import CookiesModal from './components/CookiesModal.vue'
import Footer from './components/FooterComponent.vue'
import Header from './components/HeaderComponent.vue'
//import PayoutModal from './components/PayoutModal.vue';
import SellSkinModal from './components/SellSkinModal.vue'

export default {
  name: 'App',
  components: {
    SellSkinModal,
    //PayoutModal,
    Header,
    Footer,
    CookiesModal,
  },
  data: function () {
    return {
      isAuth: false,
      showResendOption: false,
      currencyCodeId: '',
      currencyOptions: [],
      pageLoaded: false,
      error: '',
      productModalIsVisible: false,
      productPageItem: {},
      textPageList: [],
      textPageTitle: '',
      textPageHeader: '',
      textPageContent: '',
      menuVisible: false,
      signInModalIsVisible: false,
      signUpModalIsVisible: false,
      successMessage: '',
      totalSum: '',
      chosenItem: '',
      loaderIsVisible: false,
      orderHistory: [],
      offerHistory: [],
      orderModalIsVisible: false,
      orderData: {},
      allPaymentMethods: [],
      availablePaymentMethods: [], // Store available payment methods for the current order
      minTopupAmount: 0,
      hostname: '',
      cookesModalIsVisible: false,
      footerCopyright: '',
      withdrawModalIsVisible: true,
      sellSkinModalIsVisible: false,
      previewSkinModalIsVisible: false,
    }
  },
  computed: {
    ...mapState('app', ['currentLanguage']),
    ...mapGetters('app', ['currencyCode', 'currencySymbol']),
    ...mapGetters('cart', ['cartContents']),
    ...mapGetters('staticPages', ['getPageByType']),
    ...mapGetters('modals', ['depositModalIsVisible', 'cartDropdownIsVisible']),
  },
  watch: {
    currentLanguage() {
      this.getTextPages()
    },
    currencyCode() {
      if (this.productPageItem && this.productPageItem.length) {
        this.getProductPageContent(this.productPageItem)
      }
      if (this.isAuth) {
        this.orderHistory = ''
        this.offerHistory = ''
        this.cartContents = ''
        this.totalSum = ''
        this.getOrderHistory()
        this.getOfferHistory()
        this.fetchCartItems()
        this.fetchUserData()
      }
    },
    $route() {
      this.error = ''
      window.scrollTo(0, 0)
      this.closeMenu()
      //this.closeCartDropdown();
      if (this.isAuth) {
        this.getOrderHistory()
        this.getOfferHistory()
      }
      this.$nextTick(() => {
        this.checkHeight()
      })
    },
  },
  methods: {
    onOfferCreated() {
      this.getOfferHistory()
    },

    checkHeight() {
      const body = document.body
      const html = document.documentElement

      const pageHeight = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
      )
      const viewportHeight = window.innerHeight || html.clientHeight

      if (pageHeight > viewportHeight) {
        body.classList.add('isScrolabal')
      } else {
        body.classList.remove('isScrolabal')
      }
    },
    clearError() {
      this.error = ''
    },
    setError(error) {
      this.error = error
    },
    openPreviewSkinModal() {
      this.previewSkinModalIsVisible = true
      document.body.style.overflowY = 'hidden'
    },
    closePreviewSkinModal() {
      this.previewSkinModalIsVisible = false
      document.body.style.overflowY = 'auto'
      this.error = ''
    },
    openSellSkinModal() {
      this.sellSkinModalIsVisible = true
      document.body.style.overflowY = 'hidden'
    },
    closeSellSkinModal() {
      this.sellSkinModalIsVisible = false
      document.body.style.overflowY = 'auto'
      this.error = ''
    },
    closeWithdraw() {
      this.withdrawModalIsVisible = false
      document.body.style.overflowY = 'auto'
      const app = document.getElementById('app')
      if (app) app.style.overflowY = 'auto'
      this.error = ''
    },
    openWithdraw() {
      this.withdrawModalIsVisible = true
      document.body.style.overflowY = 'hidden'
      const app = document.getElementById('app')
      if (app) app.style.overflowY = 'auto'
    },
    ...mapActions('app', ['fetchCurrencies', 'changeCurrency']),
    ...mapActions('modals', ['closeDepositModal']),
    ...mapActions('user', ['fetchUserData']),
    ...mapActions('cart', [
      'fetchCartItems',
      'clearCart',
      'updateCartContents',
    ]),
    ...mapActions('staticPages', ['fetchPages', 'fetchPageContent']),
    async fetchPaymentMethods(countryId, currencyCode) {
      this.$http
        .post('orders/payment-methods', {
          country: countryId,
          currency: currencyCode,
        })
        .then((response) => {
          if (response.data.status === 'OK') {
            this.availablePaymentMethods = response.data.payload
          } else {
            this.error = this.$t(response.data.message)
          }
        })
        .catch((error) => {
          console.error('Error fetching payment methods:', error)
          this.error = this.$t('Error fetching payment methods')
        })
    },
    resendVerificationEmail(data) {
      this.error = ''
      this.$http
        .post('resendConfirmationLink', {
          email: data,
        })
        .then((res) => {
          if (res.data.status == 'OK') {
            this.error = ''
            this.successMessage = this.$t('Confirmation link has been resent.')
          } else {
            this.error = this.$t(res.data.message)
            this.successMessage = ''
          }
        })
        .catch((res) => {
          this.error = this.$t(res.response.data.message)
        })
    },
    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
      )
    },
    orderSubmit(data, type) {
      data.paymentType = type
      data.currency = this.currencyCode
      this.$http
        .post('orders/checkout', data)
        .then((res) => {
          if (res.data.status == 'ERROR') {
            this.$router.push({ name: 'PaymentFailPage' })
            this.closeOrderModal()
          } else {
            window.location = res.data.redirect_url
          }
        })
        .catch((res) => {
          this.$toast.error(this.$t(res.response.data.message), {
            multiple: false,
          })
          this.error = this.$t(res.response.data.message)
        })
    },
    getOrderHistory() {
      this.$http
        .get('purchase/history')
        .then((res) => {
          this.orderHistory = res.data.payload
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$router.push('/signin')
          }
        })
    },
    getOfferHistory() {
      this.$http
        .get('offer/history')
        .then((res) => {
          this.offerHistory = res.data.payload
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            this.$router.push('/signin')
          }
        })
    },
    addToCart(item) {
      if (!this.isAuth) {
        this.$router.push('/signin')
      } else {
        let self = this

        let cartItem = {
          id: item.id,
          count: 1,
        }

        for (var i = 0; i < this.cartContents.length; i++) {
          if (this.cartContents[i].item_id == item.id) {
            let cartItemCount = this.cartContents[i].count
            cartItem = {
              ...cartItem,
              count: cartItemCount + 1,
            }
            break
          }
        }
        this.loaderIsVisible = true
        this.$http
          .post('cart/add', cartItem)
          .then((res) => {
            self.loaderIsVisible = false
            self.fetchCartItems()
            self.chosenItem = cartItem.id
            self.updateCartContents(res.data.cart)
            setTimeout(() => {
              self.chosenItem = ''
            }, 2000)
          })
          .catch((res) => {
            self.loaderIsVisible = false
            if (res.response.status === 401) {
              this.$router.push('/signin')
            } else {
              self.error = this.$t(res.response.data.message)
              setTimeout(() => {
                self.error = ''
              }, 2000)
            }
          })
      }
    },
    removeOneFromCart(item) {
      let self = this
      let cartItem = {
        id: item.id,
        count: '1',
      }
      if (item.count > 1) {
        cartItem = {
          ...cartItem,
          count: item.count - 1,
        }
        this.$http
          .post('cart/add', cartItem)
          .then(() => {
            self.fetchCartItems()
          })
          .catch(() => {})
      } else {
        this.removeFromCart(item)
      }
    },

    removeFromCart(item) {
      let self = this
      let cartItem = {
        id: item.id,
      }
      this.$http
        .post('cart/remove', cartItem)
        .then(() => {
          self.fetchCartItems()
        })
        .catch(() => {})
    },
    checkIsAuth() {
      this.$http
        .get('is-auth')
        .then((res) => {
          this.isAuth = res.data.authenticated
          console.log('checkIsAuth', this.isAuth)
          if (res.data.authenticated) {
            this.fetchCartItems()
            this.getOrderHistory()
            this.getOfferHistory()
            this.fetchUserData()
          }
        })
        .catch(() => {})
    },
    login(data) {
      this.loaderIsVisible = true
      this.showResendOption = false

      this.$http
        .post('login', data)
        .then((res) => {
          this.loaderIsVisible = false
          if (res.data.status == 'OK') {
            this.isAuth = true
            this.fetchCartItems()
            this.getOrderHistory()
            this.getOfferHistory()
            this.fetchUserData()
          } else {
            this.error = this.$t(res.data.message)
          }
        })
        .catch((res) => {
          this.loaderIsVisible = false
          this.error = this.$t(res.response.data.message)
          if (res.response.data.status === 'VERIFY') {
            this.showResendOption = true
          }
        })
    },
    forgotPass(data) {
      let self = this
      self.loaderIsVisible = true
      return this.$http
        .post('user/reset-password', data)
        .then((res) => {
          self.loaderIsVisible = false
          if (res.data.status == 'OK') {
            self.successMessage = res?.data?.message
              ? this.$t(res?.data?.message)
              : 'Success'
            self.error = ''
            setTimeout(() => {
              self.successMessage = ''
            }, 2500)
          } else {
            this.error = this.$t(res.response.data.message)
          }
        })
        .catch((error) => {
          self.loaderIsVisible = false
          this.error = this.$t(error.response.data.message)
        })
    },
    registration(data) {
      if (
        !/^[a-zA-Z\s-]+$/.test(data.name) ||
        !/^[a-zA-Z\s-]+$/.test(data.surname)
      ) {
        this.error = this.$t(
          'First name and Last name must only contain letters',
        )
        return
      }
      let self = this
      self.loaderIsVisible = true
      this.$http
        .post('register', data)
        .then((res) => {
          self.loaderIsVisible = false
          if (res.data.status == 'OK') {
            self.clearError()
            this.isAuth = true
            this.fetchCartItems()
            this.getOrderHistory()
            this.getOfferHistory()
            this.fetchUserData()
            this.$router.push('/profile/personal-information')
          } else {
            self.error = this.$t(res.data.message)
            this.isAuth = false
          }
        })
        .catch((res) => {
          self.loaderIsVisible = false
          this.error = this.$t(res.response.data.message)
          this.isAuth = false
        })
    },
    logout() {
      this.$http
        .post('logout')
        .then(() => {
          if (this.$route.name != 'Home') {
            this.$router.push({ path: '/' })
          }
          this.isAuth = false
          this.$router.push({ path: '/' })
        })
        .catch((res) => {
          if (res.response.status === 401) {
            console.log(res)
          }
        })
    },
    getProductPageContent(item) {
      this.productPageItem = ''
      const apiEndpoint = `items/${item.id}`
      this.$http
        .get(`${apiEndpoint}`, {
          params: { currency: this.currencyCode },
        })
        .then((res) => {
          this.productPageItem = res.data.payload
        })
        .catch((error) => {
          this.error = this.$t('Failed to load product data.')
          console.error(error)
        })
    },
    goToProduct(item) {
      const id = item.id
      this.$router.push({ name: 'ProductPage', params: { id: id } })
    },
    hideResendOption() {
      this.showResendOption = false
    },
    getTextPages() {
      this.fetchPages(this.currentLanguage)
    },
    closeMenu() {
      this.menuVisible = false
      document.body.style.overflowY = 'auto'
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible
      //window.scrollTo(0, 0);
      if (this.menuVisible) {
        document.body.style.overflowY = 'hidden'
      } else {
        document.body.style.overflowY = 'auto'
      }
    },
    // menuHeight() {
    //   const doc = document.documentElement;
    //   doc.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    // },
    getSettings() {
      this.$http
        .get('settings')
        .then((res) => {
          this.minTopupAmount = res.data.payload.min_top_up
          this.allPaymentMethods = res.data.payload.payment_methods
          this.footerRequisites = res.data.payload.requisites
          this.footerSupportEmail = res.data.payload.support_email
          this.footerCopyright = res.data.payload.copyright
          console.log(
            'res.data.payload.payment_methods',
            res.data.payload.payment_methods,
          )
          const snippet = res.data.payload.google_tag
          if (snippet) {
            loadScriptsFromString(snippet).catch((error) => {
              console.error('Error loading Google Tag snippet:', error)
            })
          }

          const chatbotScript = res.data.payload.chatbot_script
          if (chatbotScript) {
            loadScriptsFromString(chatbotScript).catch((error) => {
              console.error('Error loading Chatbot script:', error)
            })
          }
        })

        .catch(() => {})
    },
    ...mapActions('app', ['fetchLanguages']),
  },
  created() {
    // Make constants available in template
    this.TERMS_PAGE = TERMS_PAGE
    this.PRIVACY_PAGE = PRIVACY_PAGE
    this.COOKIE_PAGE = COOKIE_PAGE
  },
  mounted: async function () {
    let self = this
    self.fetchLanguages()
    this.fetchCurrencies()
    self.getTextPages()
    // self.menuHeight();
    self.getSettings()
    self.checkIsAuth()
    self.hostname = self.getDomainName(window.location.hostname)
    // window.addEventListener("resize", self.menuHeight);
    setTimeout(function () {
      self.pageLoaded = true
    }, 300)
  },
}
</script>
